// import React from "react";
// import styled from "styled-components";
// import RotatingText from "./RotatingText";

// // Main Component
// const HeroComponent = () => {
//   const services = [
//     {
//       title: "Apply For Fresh Passport Assistance",
//     },
//     {
//       title: "Apply Re-issue Passport Assistance",
//     },
//     {
//       title: "Download Appointment Receipt ",
//     },
//     {
//       title: "Requried Document For Passport",
//     },
//     {
//       title: "Change in Name Assistance",
//     },
//     {
//       title: "Requried Document For Visa",
//     },
//     {
//       title: "Apply For Visa",
//     },
//     {
//       title: "Online Payment",
//     },
//   ];
//   return (
//     <HeroSection>
//       <HeroContainer>
//         <Title>
//           Our Services
//           <span>
//             <RotatingText
//               texts={services.map((s) => s.title)}
//               mainClassName="px-2 sm:px-2 md:px-3 bg-cyan-300 text-black overflow-hidden py-0.5 sm:py-1 md:py-2 justify-center rounded-lg"
//               staggerFrom={"last"}
//               initial={{ y: "100%" }}
//               animate={{ y: 0 }}
//               exit={{ y: "-120%" }}
//               staggerDuration={0.025}
//               splitLevelClassName="overflow-hidden pb-0.5 sm:pb-1 md:pb-1"
//               transition={{ type: "spring", damping: 30, stiffness: 400 }}
//               rotationInterval={2000}
//             />
//           </span>
//         </Title>
//         <Description>
//           We provide comprehensive passport assistance services including new
//           applications, reissues, updates, and online payments. Your trusted
//           partner for a smooth and efficient passport process.
//         </Description>
//         <ButtonGroup>
//           <PrimaryButton>Discuss for Passport Service</PrimaryButton>
//           <LinkButton href="#">Our Services</LinkButton>
//         </ButtonGroup>
//       </HeroContainer>

//       {/* Decorative dots/stars/circles */}
//       <Dot size="60px" striped top="10%" left="80%" />
//       <Dot size="80px" striped top="60%" left="70%" />
//       <Dot size="20px" color="#a03fff" top="70%" left="45%" />
//       <Dot size="14px" color="#fff" top="75%" left="55%" />
//       <Dot size="20px" color="#a03fff" top="5%" left="90%" />
//     </HeroSection>
//   );
// };

// export default HeroComponent;

import React from "react";
import styled from "styled-components";
import RotatingText from "./RotatingText";

// Main Component
const HeroComponent = () => {
  const services = [
    { title: "Apply For Fresh Passport Assistance" },
    { title: "Apply Re-issue Passport Assistance" },
    { title: "Download Appointment Receipt" },
    { title: "Requried Document For Passport" },
    { title: "Change in Name Assistance" },
    { title: "Requried Document For Visa" },
    { title: "Apply For Visa" },
    { title: "Online Payment" },
  ];

  return (
    <HeroSection>
      <HeroContainer>
        <Title>
          Our Services
          <span>
            <RotatingText
              texts={services.map((s) => s.title)}
              mainClassName="px-2 sm:px-2 md:px-3 bg-cyan-300 text-black overflow-hidden py-0.5 sm:py-1 md:py-2 justify-center rounded-lg"
              staggerFrom={"last"}
              initial={{ y: "100%" }}
              animate={{ y: 0 }}
              exit={{ y: "-120%" }}
              staggerDuration={0.025}
              splitLevelClassName="overflow-hidden pb-0.5 sm:pb-1 md:pb-1"
              transition={{ type: "spring", damping: 30, stiffness: 400 }}
              rotationInterval={2000}
            />
          </span>
        </Title>
        <Description>
          We provide comprehensive passport assistance services including new
          applications, reissues, updates, and online payments. Your trusted
          partner for a smooth and efficient passport process.
        </Description>
        <ButtonGroup>
          <PrimaryButton>Discuss for Passport Service</PrimaryButton>
          <LinkButton href="#">Our Services</LinkButton>
        </ButtonGroup>
      </HeroContainer>
    </HeroSection>
  );
};

export default HeroComponent;

// style css
// const HeroContainer = styled.div`
//   max-width: 1300px;
//   margin: 0 auto;
// `;

// const HeroSection = styled.section`
//   width: 100%;
//   height: 567.03px;
//   margin: auto;
//   background: linear-gradient(145deg, #0d0d0d, #1a1a1a);
//   padding: 60px;
//   border: 1px solid #1f1f21;

//   position: relative;
//   color: #fff;
//   font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
//   overflow: hidden;

//   @media (max-width: 768px) {
//     padding: 40px 20px;
//     height: auto;
//   }
// `;

// const Title = styled.h1`
//   font-size: 2.5rem;
//   font-weight: 300;
//   line-height: 1.3;
//   color: #ffffff;

//   span {
//     /* font-weight: 700; */
//     font-size: 4.5rem;

//     color: #246bfd;
//     margin-top: 0.2em;
//   }

//   @media (max-width: 768px) {
//     font-size: rem;
//   }

//   @media (max-width: 768px) {
//     span {
//       font-size: 2.5rem;
//     }
//   }
// `;

// const Description = styled.p`
//   margin-top: 20px;
//   max-width: 600px;
//   font-size: 1.1rem;
//   color: #b3b3b3;
// `;

// const ButtonGroup = styled.div`
//   margin-top: 30px;
//   display: flex;
//   gap: 20px;
//   align-items: center;
//   flex-wrap: wrap;
// `;

// const PrimaryButton = styled.button`
//   background: linear-gradient(to right, #3f51ff, #6f41ff);
//   color: white;
//   padding: 12px 20px;
//   border-radius: 20px;
//   font-size: 1.1rem;
//   border: none;
//   cursor: pointer;
//   transition: 0.3s;

//   &:hover {
//     opacity: 0.9;
//   }
// `;

// const LinkButton = styled.a`
//   color: #fff;
//   /* font-size: 0.9rem; */
//   font-size: 1.1rem;

//   text-decoration: none;
//   display: flex;
//   align-items: center;

//   &:after {
//     content: "→";
//     margin-left: 8px;
//     font-size: 1rem;
//   }
// `;

// // Decorative Elements
// const Dot = styled.div`
//   position: absolute;
//   border-radius: 50%;
//   background: ${({ color }) => color || "#ffffff"};
//   width: ${({ size }) => size || "20px"};
//   height: ${({ size }) => size || "20px"};
//   top: ${({ top }) => top};
//   left: ${({ left }) => left};
//   transform: ${({ rotate }) => rotate && `rotate(${rotate})`};
//   background-image: ${({ striped }) =>
//     striped
//       ? "repeating-linear-gradient(45deg, #333 0, #333 5px, transparent 5px, transparent 10px)"
//       : "none"};
// `;

const HeroContainer = styled.div`
  max-width: 1300px;
  margin: 0 auto;
`;

const HeroSection = styled.section`
  width: 100%;
  height: 567.03px;
  margin: auto;
  background: linear-gradient(145deg, #0d0d0d, #1a1a1a);
  padding: 60px;
  border: 1px solid #1f1f21;

  position: relative;
  color: #fff;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 40px 20px;
    height: auto;
  }
`;

const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 300;
  line-height: 1.3;
  color: #ffffff;

  span {
    font-size: 4.5rem;
    color: #246bfd;
    margin-top: 0.2em;
  }

  @media (max-width: 768px) {
    font-size: 2rem;
    span {
      font-size: 2.5rem;
    }
  }
`;

const Description = styled.p`
  margin-top: 20px;
  max-width: 600px;
  font-size: 1.1rem;
  color: #b3b3b3;
`;

const ButtonGroup = styled.div`
  margin-top: 30px;
  display: flex;
  gap: 20px;
  align-items: center;
  flex-wrap: wrap;
`;

const PrimaryButton = styled.button`
  background: linear-gradient(to right, #3f51ff, #6f41ff);
  color: white;
  padding: 12px 20px;
  border-radius: 20px;
  font-size: 1.1rem;
  border: none;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    opacity: 0.9;
  }
`;

const LinkButton = styled.a`
  color: #fff;
  font-size: 1.1rem;
  text-decoration: none;
  display: flex;
  align-items: center;

  &:after {
    content: "→";
    margin-left: 8px;
    font-size: 1rem;
  }
`;
